import { useState } from "react";
import { Link } from "react-router-dom";
import { AdListing } from "types/adListing";

interface AdListImageProps {
  ilan: AdListing;
  style: React.CSSProperties;
  detailLink?: string;
  disableDetailLinks?: boolean;
}

export default function AdListImage({ ilan, style, detailLink, disableDetailLinks = false }: AdListImageProps) {
  const [hasError, setHasError] = useState(!ilan.resimUrl);

  const placeholder = (
    <div
      className="card-img-top d-flex flex-column align-items-center justify-content-center bg-light text-muted"
      style={style}
      aria-label="Görsel yok"
    >
      <i className="fas fa-image fa-3x mb-2" style={{ opacity: 0.35 }} />
      <span className="small" style={{ fontSize: '0.75rem' }}>Görsel Yok</span>
    </div>
  );

  const image = hasError ? placeholder : (
    <img
      src={ilan.resimUrl!}
      className="card-img-top"
      alt={ilan.baslik}
      style={style}
      onError={() => setHasError(true)}
    />
  );

  if (disableDetailLinks) {
    return image;
  }

  const to = detailLink ?? `/ilan-detay/${ilan.id}`;
  return <Link to={to}>{image}</Link>;
}